import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import './styles.less';

interface ContainerProps {
  children: JSX.Element;
}

const { Text, Title } = Typography;

const Container = ({ children }: ContainerProps) => {
  const { t } = useTranslation();
  return (
    <>
      <div className="domains-input__container-header" id="header">
        <div>
          <Title level={4}>{t('profileInputs.azDomains.title')}</Title>
          <Text type="secondary">{t('profileInputs.azDomains.subtitle')}</Text>
        </div>
      </div>
      <div className="domains-input__container" id="childrenContainer">
        {children}
      </div>
    </>
  );
};

export default Container;
